$(document).ready(function() {
  let dealersAll = [],
      dealersUSA = [],
      dealersCanada = [],
      dealersMexico = [],
      dealersAustralia = [],
      dealersOnline = [],
      dealersNearby = [],
      geocoder,
      map,
      infowindow = null,
      markers = [],
      dealersContainer = document.getElementById('all-dealers'),
      directionsDisplay = '',
      bounds = '';

  const nameIndex = 0,
        streetIndex = 1,
        cityIndex = 2,
        postalCodeIndex = 3,
        countryIndex = 4,
        phoneIndex = 5,
        websiteIndex = 6,
        onlineIndex = 7,
        latIndex = 9,
        longIndex = 10,
        locationIndex = 11,
        distanceIndex = 12;

  function loadGapi() {
    gapi.load('client', initGapiClient);
  }

  function initGapiClient() {
    gapi.client.init({
      apiKey: 'AIzaSyAGMFKrk20shGRTX7hvQt17gkwV8gBGt0o'
    }).then(loadSheet).catch(function(error) {
      console.error("Error initializing GAPI client", error);
    });
  }

  function loadSheet() {
    return gapi.client.load("https://content.googleapis.com/discovery/v1/apis/sheets/v4/rest")
      .then(() => {
          console.log("GAPI client loaded for API");

          const input = document.getElementById('address'),
                searchBox = new google.maps.places.SearchBox(input);
          getSheetData();
        }, (err) => {
          console.error("Error loading GAPI client for API", err);
        }
      );
  }

  function getSheetData() {
    return gapi.client.sheets.spreadsheets.values.get({
      "spreadsheetId": "1AX74YI4WCG9r1NWql0K9QGOeFCnoYWYmME3yNn4-6io",
      "range": "A2:K10000",
      "majorDimension": "ROWS",
      "valueRenderOption": "FORMATTED_VALUE"
    }).then((response) => {
      if(response) {
        dealersAll = response.result.values;

        dealersAll.sort((a,b) => {
          if (a[nameIndex] < b[nameIndex]) return -1;
          if (a[nameIndex] > b[nameIndex]) return 1;
          return 0;
        });

        initMap();  // Initialize the map before showing dealers

        showDealers(dealersAll);

        dealersAll.forEach((dealer, i) => {
          if(dealer[countryIndex].toLowerCase() === 'usa') {
            dealersUSA.push(dealer);
          } else if (dealer[countryIndex].toLowerCase() === 'canada') {
            dealersCanada.push(dealer);
          } else if (dealer[countryIndex].toLowerCase() === 'mexico') {
            dealersMexico.push(dealer);
          } else if (dealer[countryIndex].toLowerCase() === 'australia') {
            dealersAustralia.push(dealer);
          }
          if(dealer[onlineIndex].toLowerCase() === 'yes') {
            dealersOnline.push(dealer);
          }
        });
        setMarkers(dealersAll);
      } else {
        console.log("Could not get sheet data");
      }
    }, (err) => {
      console.error("Execute error", err);
    });
  }

  function initMap() {
    geocoder = new google.maps.Geocoder();
    map = new google.maps.Map(document.getElementById('map'), {
      zoom: 4,
      center: {lat: 40.712776, lng: -74.005974}  // Default to New York
    });
    bounds = new google.maps.LatLngBounds();
  }

  function scrollToElement(id) {
    var topPos = document.getElementById(id).offsetTop;
    document.getElementById('all-dealers').scrollTop = topPos-10;
  }

  function getDistance(lat1, lon1, lat2, lon2) {
    var p = 0.017453292519943295;    // Math.PI / 180
    var c = Math.cos;
    var a = 0.5 - c((lat2 - lat1) * p)/2 +
            c(lat1 * p) * c(lat2 * p) *
            (1 - c((lon2 - lon1) * p))/2;

    return 12742 * Math.asin(Math.sqrt(a)); // 2 * R; R = 6371 km
  }

  function toRad(Value) {
    return Value * Math.PI / 180;
  }

  function clearMarkers() {
    markers.forEach((marker) => {
      marker.setMap(null);
    });
    // Reset bounds
    bounds = new google.maps.LatLngBounds();
  }

  function setMarkers(data) {
    // clear existing markers
    clearMarkers();

    data.forEach((dealer,i) => {
      var marker = new google.maps.Marker({
          map: map,
          position: {
            lat: Number(dealer[latIndex]),
            lng: Number(dealer[longIndex])
          },
          title: dealer[nameIndex],
          label: (i + 1).toString()
      });

      markers.push(marker);

      if(!dealer[locationIndex]) {
        dealer.push({
              lat: Number(dealer[latIndex]),
              lng: Number(dealer[longIndex])
            });
      }

      bounds.extend(marker.position);

      var content = `
        <div class="dealer-container">
          <div class="row m-0">
            <div class="col-12 p-0">
              <h4 class="dealer-title">${dealer[nameIndex].toUpperCase()}</h4>
              <div class="street">
                <i class="fas fa-location-arrow ml-4 mr-1"></i>
                ${dealer[streetIndex]}
              </div>
              <div class="location">${dealer[cityIndex]}, ${dealer[postalCodeIndex]}, ${dealer[countryIndex]}</div>
              <div class="website">
                <i class="fas fa-globe mr-1 ml-4"></i>
                <a href="${dealer[websiteIndex]}">Website</a>
              </div>
              <div class="website">
                <i class="fas fa-phone mr-1 ml-4"></i>
                <a href="tel:${dealer[phoneIndex]}">${dealer[phoneIndex]}</a>
              </div>
            </div>
          </div>
        </div>`;

      marker.addListener('click', () => {
        if (infowindow) { infowindow.close(); }
        infowindow = new google.maps.InfoWindow({ content });
        infowindow.open(map, marker);
        map.panTo(marker.getPosition());
        scrollToElement(`dealer-${i}`);
      });

      $(`#dealer-${i}`).click((e) => {
        if (infowindow) { infowindow.close(); }
        infowindow = new google.maps.InfoWindow({ content });
        infowindow.open(map, marker);
        map.panTo(marker.getPosition());
        scrollToElement(`dealer-${i}`);
      });

      map.fitBounds(bounds);
    });
  }

  function showDealers(data) {
    dealersContainer.innerHTML = '';
    setMarkers(data);
    data.forEach((dealer,i) => {
      if (i % 2 === 0) {
        // if the row index is even
        dealersContainer.innerHTML +=
        `<div id="dealer-${i}" class="dealer-container">
          <div class="row">
            <div class="col-1 p-0 dealer-locator_dealer-info-box_title_wrapper">
              <h4 class="dealer-title">${dealer[nameIndex].toUpperCase()}</h4>
            </div>
            <div class="col-11 p-0">
              <div class="street">
                ${dealer[streetIndex]}
              </div>
              <div class="location">${dealer[cityIndex]}, ${dealer[postalCodeIndex]}, ${dealer[countryIndex]}</div>
              <div class="website">
                <a href="${dealer[websiteIndex]}">Website</a>
              </div>
              <div class="website">
                <a href="tel:${dealer[phoneIndex]}">${dealer[phoneIndex]}</a>
              </div>
            </div>
          </div>
        </div>`;
      } else {
        // if the row index is odd, add an extra class to the first div for styling
        dealersContainer.innerHTML +=
        `<div id="dealer-${i}" class="dealer-container dealer-container-2">
          <div class="row">
            <div class="col-1 p-0 dealer-locator_dealer-info-box_title_wrapper">
              <h4 class="dealer-title">${dealer[nameIndex].toUpperCase()}</h4>
            </div>
            <div class="col-11 p-0">
              <div class="street">
                ${dealer[streetIndex]}
              </div>
              <div class="location">${dealer[cityIndex]}, ${dealer[postalCodeIndex]}, ${dealer[countryIndex]}</div>
              <div class="website">
                <a href="${dealer[websiteIndex]}">Website</a>
              </div>
              <div class="website">
                <a href="tel:${dealer[phoneIndex]}">${dealer[phoneIndex]}</a>
              </div>
            </div>
          </div>
        </div>`;
      }
    });
    map.fitBounds(bounds);

    $('.num-box').each((i, box) => {
      if(box.innerHTML < 10) {
        box.className += ' single';
      }
      if(box.innerHTML > 99) {
        box.className += ' num-hundred';
      }
    });
  }

  $('#category').change((e) => {
    const category = $('#category').find(':selected').val();

    if(category === 'all') {
      showDealers(dealersAll);
    } else if (category === 'usa') {
      showDealers(dealersUSA);
    } else if (category === 'canada') {
      showDealers(dealersCanada);
    } else if (category === 'mexico') {
      showDealers(dealersMexico);
    } else if (category === 'australia') {
      showDealers(dealersAustralia);
    }
    if (category === 'online') {
      showDealers(dealersOnline);
    }
  });

  $('#search-submit').click(() => {
    const userAddress = $('#address').val(),
          distance = $('#distance').val();

    if(userAddress) {
      dealersNearby = [];

      geocoder.geocode({ address: userAddress }, (result) => {
        var userLat = result[0].geometry.location.lat(),
            userLong = result[0].geometry.location.lng();

        const kmToMilesConversion = 1.60934;
        dealersAll.forEach((dealerAll, index, array) => {
          if(getDistance(userLat, userLong, dealerAll[latIndex], dealerAll[longIndex]) < distance) {
            dealerAll.push((getDistance(userLat, userLong, dealerAll[latIndex], dealerAll[longIndex])/kmToMilesConversion).toString().substring(0,6));
            dealersNearby.push(dealerAll);
          }
          if (index === array.length - 1) {
            dealersNearby.sort((a,b) => {
              if (Math.round(a[distanceIndex]) < Math.round(b[distanceIndex])) { return -1; }
              if (Math.round(a[distanceIndex]) > Math.round(b[distanceIndex])) { return 1; }
              return 0;
            });
            setMarkers(dealersNearby);
            dealersContainer.innerHTML = '';

            dealersNearby.forEach((dealer,i) => {
              if (i % 2 === 0) {
                // if the row index is even
                dealersContainer.innerHTML +=
                `<div id="dealer-${i}" class="dealer-container">
                  <div class="row">
                    <div class="col-1 p-0">
                      <div class="num-box text-white">${i + 1}</div>
                    </div>
                    <div class="col-11 p-0">
                      <h4 class="dealer-title">${dealer[nameIndex].toUpperCase().toUpperCase()}</h4>
                      <div class="street">
                        <i class="fas fa-location-arrow ml-4 mr-1"></i>
                        ${dealer[streetIndex]}
                      </div>
                      <div class="location">${dealer[cityIndex]}, ${dealer[postalCodeIndex]}, ${dealer[countryIndex]}</div>
                      <div class="website">
                        <i class="fas fa-globe mr-1 ml-4"></i>
                        <a href="${dealer[websiteIndex]}">Website</a>
                      </div>
                      <div class="website">
                        <i class="fas fa-phone mr-1 ml-4"></i>
                        <a href="tel:${dealer[phoneIndex]}">${dealer[phoneIndex]}</a>
                      </div>
                      <div class="distance">
                        <i class="fas fa-road mr-1 ml-4"></i>
                        <strong>Distance ~ ${Math.round(dealer[distanceIndex] * 10)/10} Miles</strong>
                      </div>
                      <div class="directions">
                        <i class="fas fa-map mr-1 ml-4"></i>
                        <a id="directions-${i}">Directions</a>
                      </div>
                    </div>
                  </div>
                </div>`;
              } else {
                // if the row index is odd, add an extra class to the first div for styling
                dealersContainer.innerHTML +=
                `<div id="dealer-${i}" class="dealer-container dealer-container-2">
                  <div class="row">
                    <div class="col-1 p-0">
                      <div class="num-box text-white">${i + 1}</div>
                    </div>
                    <div class="col-11 p-0">
                      <h4 class="dealer-title">${dealer[nameIndex].toUpperCase()}</h4>
                      <div class="street">
                        <i class="fas fa-location-arrow ml-4 mr-1"></i>
                        ${dealer[streetIndex]}
                      </div>
                      <div class="location">${dealer[cityIndex]}, ${dealer[postalCodeIndex]}, ${dealer[countryIndex]}</div>
                      <div class="website">
                        <i class="fas fa-globe mr-1 ml-4"></i>
                        <a href="${dealer[websiteIndex]}">Website</a>
                      </div>
                      <div class="website">
                        <i class="fas fa-phone mr-1 ml-4"></i>
                        <a href="tel:${dealer[phoneIndex]}">${dealer[phoneIndex]}</a>
                      </div>
                      <div class="distance">
                        <i class="fas fa-road mr-1 ml-4"></i>
                        <strong>Distance ~ ${Math.round(dealer[distanceIndex] * 10)/10} Miles</strong>
                      </div>
                      <div class="directions">
                        <i class="fas fa-map mr-1 ml-4"></i>
                        <a id="directions-${i}">Directions</a>
                      </div>
                    </div>
                  </div>
                </div>`;
              }
            });
            dealersNearby.forEach((dealer, i) => {
              $(`#directions-${i}`).click((e) => {
                initDirections(`${dealer[cityIndex]}, ${dealer[postalCodeIndex]}, ${dealer[countryIndex]}`);
              });
            });
          }
        });
      });
    } else {
      showDealers(dealersAll);
    }
  });

  function initDirections(destination) {
    directionsDisplay = new google.maps.DirectionsRenderer;
    const directionsService = new google.maps.DirectionsService,
        directionsContainer = document.getElementById('directions');

    directionsDisplay.setMap(map);
    $('#all-dealers').css('display','none');
    $('#directions-container').css('display','block');
    directionsDisplay.setPanel(directionsContainer);

    calculateAndDisplayRoute(directionsService, directionsDisplay, destination);
  }

  function calculateAndDisplayRoute(directionsService, directionsDisplay, destination) {
    directionsService.route({
      origin: $('#address').val(),
      destination: destination,
      travelMode: 'DRIVING'
    }, function(response, status) {
      if (status === 'OK') {
        directionsDisplay.setDirections(response);
        map.fitBounds(directionsDisplay.getDirections().routes[0].bounds);
      } else {
        window.alert('Directions request failed due to ' + status);
      }
    });
  }

  $('#close-directions').click(() => {
    $('#directions-container').css('display','none');
    $('#directions').html('');
    $('#all-dealers').css('display','block');
    directionsDisplay.setMap(null);
    map.fitBounds(bounds);
  });

  // Load Google API client library
  const script = document.createElement('script');
  script.src = 'https://apis.google.com/js/api.js';
  script.onload = loadGapi;
  document.head.appendChild(script);
});
